import useRefreshData from "src/hooks/useRefreshData";
import {
  getAssignedBuildings,
  resetFilterData,
  selectAssignedBuildingsForExport,
  setExportData,
} from "src/redux/slices/assignBuildingSlice";
import AssignedBuildingsGrid from "./AssignedBuildingsGrid";
import "./AssignedBuildings.scss";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "primereact/button";
import { ReactComponent as ExportIcon } from "../../../assets/icons/export.svg";
import { ReactComponent as AddCircle } from "../../../assets/icons/add_circle.svg";
import { useTranslation } from "react-i18next";
import AssignedBuildingsFilter from "./AssignedBuildingsFilter";
import { useCallback, useEffect, useState } from "react";
import { DownloadViewPrefixes, RoutePaths } from "src/resources/enum";
import { AssignedBuildingsOrderedColumns } from "src/resources/constant";
import { useNavigate } from "react-router";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import { exportFormattedData } from "src/utils/common";
import {
  getBuildRequestStatuses,
  getCivilDefenseContractApprovalStatus,
  getContractStatuses,
  getContractTypes,
} from "src/redux/slices/lookupSlice";

const AssignedBuildings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation(["common"]);

  const [shouldExport, setShouldExport] = useState(false);

  const breadCrumbsPaths = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const assignBuildingDataForExport = useSelector(
    selectAssignedBuildingsForExport
  );
  useRefreshData(getAssignedBuildings);

  const navigateToSearch = () => {
    navigate(RoutePaths.SearchForBuilding);
  };

  const exportFile = useCallback(() => {
    if (assignBuildingDataForExport.length > 0) {
      let mappedData = getMappedData(assignBuildingDataForExport);
      exportFormattedData(
        mappedData,
        AssignedBuildingsOrderedColumns,
        DownloadViewPrefixes.AssignedBuildings,
        t
      );
    }
  }, [assignBuildingDataForExport, t]);

  useEffect(() => {
    if (shouldExport) {
      exportFile();
      setShouldExport(false);
    }
  }, [exportFile, shouldExport]);

  useEffect(() => {
    dispatch(getContractTypes() as any);
    dispatch(getCivilDefenseContractApprovalStatus() as any);
    dispatch(getBuildRequestStatuses() as any);
    dispatch(getContractStatuses() as any);
  }, [dispatch]);

  const exportExcelHandler = (): void => {
    dispatch(getAssignedBuildings(true) as any).then(() => {
      setShouldExport(true);
    });
  };
  
  useEffect(() => {
    // reset filter data and search text
    dispatch(resetFilterData());
    dispatch(getAssignedBuildings() as any);
    dispatch(setExportData([]));
  }, []);

  return (
    <div className="py-2">
      <div className="px-3">
        <div className="d-flex justify-content-between align-items-center pb-2">
          {breadCrumbsPaths.length && (
            <h2 className="inner-page-title">
              {t(breadCrumbsPaths[breadCrumbsPaths.length - 1].label)}
            </h2>
          )}
          <div className="inner-page-search gap-2">
            <Button
              label={t("assign")}
              className=" d-flex gap-2 primary-btn m-0"
              style={{ padding: 10 }} //I think this change should be in the _theme.scss file add it to the primary-btn class
              onClick={navigateToSearch}
              icon={<AddCircle className="m-0" />}
            />
            <div className="vertical-divider"></div>
            <Button
              className="d-flex gap-2 light-primary-btn m-0"
              label={t("export")}
              icon={<ExportIcon className="m-0" />}
              onClick={exportExcelHandler}
            ></Button>
          </div>
        </div>
      </div>
      <HorizontalDivider />
      <AssignedBuildingsFilter />
      <HorizontalDivider />
      <AssignedBuildingsGrid />
    </div>
  );
};

export default AssignedBuildings;
function getMappedData(assignBuildingDataForExport: any) {
  let mappedData = assignBuildingDataForExport;
  mappedData = mappedData.map((assignedBuilding: any) => ({
    ...assignedBuilding,
    propertyID: assignedBuilding?.buildingNumber,
    activeContracts: assignedBuilding?.activeContractCount,
  }));
  return mappedData;
}
